import React from 'react'
import { connect } from 'react-redux'
import { ORDER_FILTER_STATUS } from '../../constants/filter-type';
import Dropdown from '../Dropdown/Dropdown';
import classnames from 'classnames'
import { formatFunctions } from '../../helpers/functions';
import { dataType } from '../../constants/data-type';
import '../../assets/styles/components/order/order-book.scss';
import { orderActions } from '../../actions/trading';
import { PARAMS } from '../../constants/params';
import { SERVICES_RESP } from '../../configurations';
import { openOrderCancelDialog } from '../../actions/app';
import { mobileSubLayoutAction } from '../../actions/app/mobileSubLayout.action';
import { ORDER_MODE } from "@/constants/app";
import CancelIcon from '../../assets/images/icons/mobiles/icon_cancel_normal@2x.png';
import ModifyIcon from '../../assets/images/icons/mobiles/icon_modify_normal@2x.png';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { checkSessionAction } from '@/actions/auth'
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '../Spinner/LoadingLayer';
import NoRow from '@/components/DataTable/CustomNoRow';

let IntervalRef;
class OrderBookMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orders: [],
      load:true,
    }
  }

  render() {
    const { language } = this.props;
    const { orders , load} = this.state;

    return (
      <div className='order-book-mobile-container'>
        {this.renderOrderFilterDropdown()}
        <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
        {orders.length > 0
          ? <div className="order-list">
            {orders.map(order =>
              <div key={order.orderID} className="order-item">
                <header onClick={() => this.handleViewDetail(order)}>
                  <span>{`${language.common_order_id} ${order.orderGroupID} >`}</span>
                  <span>{language[`order_type_${order.orderType.toLowerCase()}`]}</span>
                </header>
                <section className="info-list">
                <div className="info-item">
                  <label>{language.common_symbol}</label>
                  <span>{`${order.marketID}.${order.instrumentID}`}</span>
                </div>
                <div className="info-item">
                  <label>{language.common_name}</label>
                  <span>{language.lang === 'en_US'? order.instrumentName : order.instrumentChineseName}</span>
                </div>
                <div className="info-item">
                    <label>{language.common_ccy}</label>
                    <span>{order.currencyID}</span>
                  </div>
                  <div className={classnames("info-item")}>
                    <label>{language.common_buy_sell}</label>
                    <span className={classnames(order.bs === 'B' ? 'buy-color' : 'sell-color')}>
                      {language[order.bs === 'B' ? 'common_buy' : 'common_sell']}
                    </span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_price}</label>
                    <span>{formatFunctions.dataFormat(order.price, dataType.CURRENCY)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_quantity}</label>
                    <span>{formatFunctions.dataFormat(order.qty, dataType.NUMBER)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_filled_qty}</label>
                    <span>{formatFunctions.dataFormat(order.filledQty, dataType.NUMBER)}</span>
                  </div>                 
                  <div className="info-item">
                    <label>{language.common_os_quantity}</label>
                    <span>{formatFunctions.dataFormat(order.osqty, dataType.NUMBER)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_avg_price}</label>
                    <span>{formatFunctions.dataFormat(order.avgPrice, dataType.CURRENCY)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_stop_price}</label>
                    <span>{formatFunctions.dataFormat(order.stopPrice, dataType.CURRENCY)}</span>
                  </div>
                </section>
                <div className="trade-time">
                  <label>{language.common_create_time + ':'}</label>
                  <span>{formatFunctions.dataFormat(order.inputTime, dataType.LONG_DATE)}</span>
                </div>
                <div className='info-bottom-item'>
                  <span>{language[`order_status_${order.status.toLowerCase()}`]}</span>
                  {(order.isCancelable === 'Y' || order.isModifiable === 'Y') && <div className="action">
                    {order.isCancelable === 'Y' &&
                      <button onClick={() => this.handleCancel(order)}>
                        <img src={CancelIcon} className='action-img'></img>
                        {language.common_cancel}
                      </button>}
                    {order.isModifiable === 'Y' &&
                      <button onClick={() => this.handleAmend(order)}>
                        <img src={ModifyIcon} className='action-img'></img>
                        {language.ipo_modify}
                      </button>}
                </div>}
                </div>
              </div>
            )}
          </div>
          : !load && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' , width :'100%'}} />
        }
      </div>
    )
  }

  handleViewDetail = (order) => {
    mobileSubLayoutAction.openOrderJournalDetail(order)
  }

  handleAmend = (order) => {
    mobileSubLayoutAction.openOrderModification(order, res => {
      if (res) {
        this.getData();
      }
    })
  }

  handleCancel = (order) => {
    mobileSubLayoutAction.openOrderCancel(order, (res,order) => {
      if (res) {
        mobileSubLayoutAction.openOrderConfirmStatus(res,order, ORDER_MODE.CANCEL);
        if (res.isSuccess === 'Y') {
          this.getData();
        }
      }
    })
  }

  renderOrderFilterDropdown() {
    const { language } = this.props;

    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className="status-filter">
        <Dropdown options={filterOptions} style={{ height: 'unset' }}
          selectedOptions={[filterOptions[0]]}
          onChange={(opt) => this.handleFilter(opt[0])} 
          innerRef={e =>this.statusFilterRef = e}/>
      </div>
    )
  }

  handleFilter = (val) => {
    let status = '';
    switch (val.value) {
      case 'all': {
        status = '';
        break;
      }
      default: {
        status = val.value.toUpperCase();
        break;
      }
    }
    this.getData(status);
  }

  getData(status = '') {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount.clientID) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: status
      }
      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ orders: res.result.orderInfoList , load:false});
          }
        }
      })
    }
  }

  componentDidMount() {
    const refreshTime = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.refreshTime ?? 0;
    this.getData();
    if(refreshTime !== 0){
      const refreshSession = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.refreshSession ?? true;
      const checkSessionTime = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.checkSessionTime ?? 300000;
      IntervalRef = setInterval(() => {
        this.props.checkSession('',res=>{}, error=>{
          if(SERVICES_RESP.SESSION_TIMEOUT.includes(error.result.errorCode))
          clearInterval(IntervalRef)
        })
      }, checkSessionTime);
      IntervalRef = setInterval(() => {
        if(this.props.stopQutoRefresh === 'true'){
          clearInterval(IntervalRef)
        } else {
          let status = this.statusFilterRef.getValue()[0].value;
          if(status === 'all'){
            status = '';
          } else {
            status = status.toUpperCase();
          }
          this.getData(status,refreshSession);
        }
      }, refreshTime);
    }
  }

  componentWillUnmount() {
    IntervalRef && clearInterval(IntervalRef)
  }
  
  componentDidUpdate(prevProps){
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      // if(JSON.stringify(prevProps.currentTradingAccount) !== "{}"){
        this.getData()
      // }
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount
  }),
  dispatch => ({
    checkSession: (p, c, b) => dispatch(checkSessionAction(p, c, b)),
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c))
  })
)(OrderBookMobile)
